import { SharedIcon } from "../shared/shared-icon";

export function TrendingBadge() {
  return (
    <div className="trending-badge">
      <SharedIcon iconName="#trending-fire" />
    </div>
  );
}
